import Vue from 'vue'
import Vuex from 'vuex'
// import axios from './axios-auth'
// import globalAxios from 'axios'

import router from './router'
import { signup, signin, signInWithGoogle, signInWithGitHub, getCurrentUser } from "./helpers/auth";
import { auth, fdb } from "./services/firebase";
import fireStore from './helpers/db'

Vue.use(Vuex)
var store;
var changeUserListener = auth().onAuthStateChanged(function(user) {
  if (user) {
    // User is signed in.
    // console.log(user.email+ ' id: '+user.uid)
    store.commit('authUser', {
      token: user.refreshToken,
      userId: user.uid,
      user: user
    })
    fireStore.getUserData();
    fireStore.getContracts();
    if(router.currentRoute.fullPath == '/signin')
      router.replace('/dashboard')
  } else {
    // No user is signed in.
    store.commit('clearAuthData')
    // router.replace('/')
    console.log('no user');
  }
}.bind(this));

export default store = new Vuex.Store({
  state: {
    idToken: null,
    userId: null,
    user: null,
    loggedInUser: null,
    contracts:[],
    userInfo: null,
    activeContract: null,
    uploadedData: [],
    uploadedHeaders: [],
    activePretension: null
  },
  mutations: {
    authUser (state, userData) {
      state.idToken = userData.token
      state.userId = userData.userId
      state.user = userData.user
    },
    storeUser (state, user) {
      state.user = user
    },
    clearAuthData (state) {
      state.idToken= null;
      state.userId= null;
      state.user= null;
      state.loggedInUser= null;
      state.contracts=[];
      state.userInfo= null,
      state.activeContract = null;
    },
    setContracts(state, contracts){
      state.contracts = contracts;
    },
    clearContracts(state){
      state.contracts = []
    },
    setUserInfo(state, userInfo){
      state.userInfo = userInfo;
    },
    setActiveContract(state, contractId){
      state.activeContract = contractId;
    },
    clearActiveContract(state){
      state.activeContract = null
    },
    setUploadedData(state, data){
      state.uploadedData = data;
    },
    clearUploadedData(state){
      state.uploadedData = []
    },
    setUploadedHeaders(state, data){
      state.uploadedHeaders = data;
    },
    clearUploadedHeaders(state){
      state.uploadedHeaders = []
    },
    setActivePretension(state, data){
      state.activePretension = data;
    },
    clearActivePretension(state){
      state.activePretension = null
    }
  },
  actions: {
    setLogoutTimer ({commit}, expirationTime) {
      setTimeout(() => {
        commit('clearAuthData')
      }, expirationTime * 1000)
    },
    signup2 ({commit, dispatch}, authData) {

      auth().createUserWithEmailAndPassword(authData.email, authData.password)
      .then(res=>{
        //we need to save the rest of the data
        
        authData.uid = res.user.uid;
        var docRef = fdb.doc('users/'+res.user.uid);
        docRef.set(authData)
        .then(()=>{
          console.log('user saved properly')
          router.replace('/dashboard')
        }).error(err=>{
          console.log(err.message);
        })

      })
      .catch(error => console.log(error))

     
    },
    login ({commit, dispatch}, authData) {
      console.log('inside login. before attemp')

      //check if it's logged in
      var user = getCurrentUser();

      signin(authData.email, authData.password).then(res =>{
        console.log('**inside login ',res)
          commit('authUser', {
            token: res.user.refreshToken,
            userId: res.user.uid,
            user: res.user
          })
        router.replace('/dashboard')
      }).catch(error => console.log('Login error: ',error));
    },
    logout ({commit}) {
      auth().signOut().then(()=>{
        router.replace('/signin');
      })
      commit('clearAuthData');
      router.replace('/signin')
    },
    storeUser ({commit, state}, userData) {
      if (!state.idToken) {
        return
      }
      // globalAxios.post('/users.json' + '?auth=' + state.idToken, userDatadddvxc )
      //   .then(res => console.log(res))
      //   .catch(error => console.log(error))
    },
    fetchUser2({commit, state}){
      console.log('**fetch user 2')
      var uid2 =state.user.uid;
      var uid= auth().currentUser.uid;
      // db.ref('/users/').once('value').then(res=>{
      //   console.log('fetchuser2',res.val());
      // })
    },
    goToArriendo({commit}){
      router.replace('/arriendo')
    },
    goToContractViewer({commit}){
      router.replace('/contractViewer')
    },
    goToPretension({commit}){
      router.replace('/pretension')
    },
    goToPretensionAvanzado({commit}){
      router.replace('/pretensionAvanzado')
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    userInfo (state) {
      return state.userInfo
    },
    userId (state) {
      return state.userId
    },
    isAuthenticated (state) {
      return  state.user != null;
    },
    contracts (state) {
      return  state.contracts;
    },
    uploadedData (state) {
      return  state.uploadedData;
    },
    uploadedHeaders (state) {
      return  state.uploadedHeaders;
    },
    activePretension(state){
      return  state.activePretension;
    }
  }
})


// WEBPACK FOOTER //
// ./src/store.js